import { Box } from "@chakra-ui/react";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as CameraIcon } from "./camera.svg";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";

export default function Avatar({ onClick, croppedAvatar, avatar, ...rest }) {
  return (
    <Box
      width="64px"
      cursor="pointer"
      height="64px"
      position="relative"
      onClick={onClick}
      {...rest}
    >
      <CorrespondingAvatar
        width="64px"
        height="64px"
        avatar={avatar}
        customAvatar={croppedAvatar}
      />

      <Box
        bg="surfaceElevated1"
        p="2px"
        borderRadius="100%"
        position="absolute"
        bottom="0"
        right="0"
      >
        <Box bg="primary" p="4px" borderRadius="100%">
          <SvgContainer icon={CameraIcon} fill="white" size="12px" />
        </Box>
      </Box>
    </Box>
  );
}
